var _defs, _polygon, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNovpocket01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-186{fill:#fff;stroke:#000;stroke-miterlimit:10;stroke-width:4px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "326.24 276.94 84.64 276.94 103.43 218.12 345.02 218.12 326.24 276.94"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.48,
    y: 247.71,
    width: 438.82,
    height: 10.95,
    transform: "translate(207.47 -80.71) rotate(38.93)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1.48,
    y: 247.71,
    width: 438.82,
    height: 10.95,
    transform: "translate(546.56 313.23) rotate(141.07)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovpocket01);
export default __webpack_public_path__ + "static/media/NO V POCKET-01.4c7b9ffe18647359d24b08acd542f0ca.svg";
export { ForwardRef as ReactComponent };